export default __webpack_public_path__ + "static/media/15--sad--face-emoticons-emoji.be7b07d9.svg";